export default {
  mounted(el, binding) {
    const margins = {
      min: '-100px 0px 100px 0px',
      mid: '-300px 0px 300px 0px',
      max: '-500px 0px 500px 0px',
    };

    const optionLazyload = {
      root: null,
      rootMargin: margins[binding.arg] || '0px',
      threshold: [0],
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const lazyImage = entry.target;
        if (entry.intersectionRatio > 0) {
          lazyImage.src = binding.value;
          lazyImage.classList.add('visible');
          io.unobserve(lazyImage);
        }
      });
    }, optionLazyload);

    io.observe(el);
  },
};
